import React, { useState } from "react";
import { FormFieldSet } from "../../../../../components";
import { EMAIL_PROPS, PropsTable } from "./Props/Props";

const CATEGORIES = {
  core:     { label: "Core",     color: "#EFF6FF", textColor: "#1D4ED8" },
  display:  { label: "Display",  color: "#F0FDF4", textColor: "#15803D" },
  behavior: { label: "Behavior", color: "#FFFBEB", textColor: "#B45309" },
};



function EmailList() {
  const [emails, setEmails] = useState([]);
  const [emailsFilled, setEmailsFilled] = useState([
    "vamsh@gmail.com",
    "pushpak@gmail.com",
  ]);
  const [emailsDisabled, setEmailsDisabled] = useState([]);
  const [emailsFilledDisabled, setEmailsFilledDisabled] = useState([
    "vamsh@gmail.com",
    "pushpak@gmail.com",
  ]);

  return (
    <div>
      <div className="grid grid-cols-4 gap-3 my-5 mb-30">
        <FormFieldSet value={emails} type="email" onChange={setEmails} multiple />
        <FormFieldSet
          value={emailsFilled}
          type="email"
          onChange={setEmailsFilled}
          multiple
          shadow={true}
        />
        <FormFieldSet
          value={emailsDisabled}
          type="email"
          onChange={setEmailsDisabled}
          multiple
          disabled
        />
        <FormFieldSet
          value={emailsFilledDisabled}
          type="email"
          onChange={setEmailsFilledDisabled}
          multiple
          disabled
          shadow={true}
        />
      </div>

      <PropsTable
        data={EMAIL_PROPS}
        title="email — Props Reference"
        typeLabel='type="email"'
        categories={CATEGORIES}
      />
      <div className="mt-4 bg-amber-50 border border-amber-200 rounded-lg p-4 text-xs text-amber-900">
        <p className="font-medium mb-2">⚠ single vs multiple — key differences</p>
        <table className="w-full text-xs text-amber-900">
          <thead>
            <tr className="border-b border-amber-200">
              <th className="text-left py-1 pr-4 font-medium">Point</th>
              <th className="text-left py-1 pr-4 font-medium">single (default)</th>
              <th className="text-left py-1 font-medium">multiple</th>
            </tr>
          </thead>
          <tbody className="leading-relaxed">
            <tr className="border-b border-amber-100">
              <td className="py-1 pr-4 font-medium">value type</td>
              <td className="py-1 pr-4">plain <code className="bg-amber-100 px-1 rounded">string</code></td>
              <td className="py-1"><code className="bg-amber-100 px-1 rounded">string[]</code> array</td>
            </tr>
            <tr className="border-b border-amber-100">
              <td className="py-1 pr-4 font-medium">onChange receives</td>
              <td className="py-1 pr-4">raw input string (not event)</td>
              <td className="py-1">updated email array directly</td>
            </tr>
            <tr className="border-b border-amber-100">
              <td className="py-1 pr-4 font-medium">adding emails</td>
              <td className="py-1 pr-4">native input — user types freely</td>
              <td className="py-1">Enter key or paste to add chips</td>
            </tr>
            <tr>
              <td className="py-1 pr-4 font-medium">validation</td>
              <td className="py-1 pr-4">browser-native only</td>
              <td className="py-1">built-in regex — toast on invalid/duplicate</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default EmailList;